import React, { useEffect, useRef, useState } from "react";
import {
  DOCTOR_DETAIL_IAMGE,
  MATCHINGBLURICON,
  MYMATCHINGICONFORTable,
} from "../../utils/aap-image-constant";
import TableLayout from "../../components/layouts/table-layout";
import TableHeading from "../../components/common/TableHeading";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { useTranslation } from "react-i18next";
import {
  getAllJobPost,
  OpencloseClinicJobpost,
} from "../../hooks/services/api-services";
import { useSelector } from "react-redux";
import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { debounce } from "lodash";
import Input from "../../components/common/input";
import TextArea from "../../components/common/text-area";
import Modal from "../../components/common/Model";
import AccessPermissionpage from "../../components/common/accessPermissionpage";
import i18n from "../../i18n";

const JobPostList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ViewMatchingmodal = useRef();
  const isFirstRender = useRef(true);
  const [modalType, setModalType] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const payload = {
    pageIndex: searchTerm === "" ? page || 0 : 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    status: null,
    clinicId: userData?.id,
    searchText: searchTerm,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    country: "",
    address: "",
    specialization: "",
    experience: "",
    profie: "",
    type: "",
    languageType: i18n.language,
    contractType: "",
    lookingFor: "",
    availabilityPeriod: [], 
    slotType: "",
    availabilityType: "",

  };
  const [rowData, setRowData] = useState([]);
  const fetchgetAllPostData = async () => {
    setPending(true);
    try {
      const response = await getAllJobPost(payload);
      if (response?.data?.status !== 200) {
        setRowData([]);
      } else {
        const jobList = response?.data?.data?.jobPostingResponseList || [];
        const filteredJobs = jobList.filter(item => item !== null);
        setRowData(filteredJobs);
        setTotalRows(response?.data?.data?.totalElement || 0);
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      setPending(false);
      isFirstRender.current = false;
    }
  };

  const debouncedFetchData = debounce(fetchgetAllPostData, 500); // 500ms

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel(); // Cleanup function
  }, [page, pageSize, searchTerm, sortColumn, sortDirection, i18n.language]);

  const [viewData, setViewData] = useState({});

  const handleOpencloseJob = async (id, status) => {
    try {
      const response = await OpencloseClinicJobpost(id, status);
      if (response.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);
        fetchgetAllPostData();
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  // Table Columns
  const tableColumnsPosting = [
    {
      code: "s.no",
      name: t("S.No"),
      width: "100px",
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },

    {
      code: "title",
      width: "210px",
      name: t("Title"),
      sortable: true,
      selector: (row) => (
        <div className="fw-600 cursor-pointer" title={row?.title}>
          {row?.title}
        </div>
      )
    },
    {
      code: "specialty",
      name: (
        <div
          className="column-header"
          title={t("Specilization")}
        >
          {t("Specilization")}
        </div>
      ),
      width: "150px",
      sortable: true,

      selector: (row) => row?.specialty,
    },
    {
      code: "profile",
      sortable: true,
      width: "150px",
      name: t("Profile"),
      selector: (row) =>
      (
        <div className="cursor-pointer" title={row?.profile}>

          {row?.profile}
        </div>
      )
    },

    {
      code: "address",
      width: "200px",
      name: t("Address"),
      sortable: false,
      selector: (row) => (
        <div className="cursor-pointer" title={row?.location}>

          {row?.location}
        </div>
      )
    },
    {
      code: "experience",
      name: t("Experience"),
      width: "130px",
      sortable: true,
      selector: (row) => row?.experience,
    },

    {
      code: "durationFromDate",
      name: t("Start Date"),
      width: "120px",
      selector: (row) => row?.durationFromDate?.slice(0, 10),
    },
    {
      code: "durationToDate",
      name: t("End Date"),
      width: "120px",
      selector: (row) => row?.durationToDate?.slice(0, 10),
    },
    {
      code: "lookingFor",
       name: (
        <div
          className="column-header"
          title={t("lookingFor")}
        >
          {t("lookingFor")}
        </div>
      ),
      width: "150px",
      sortable: true,
      selector: (row) => row?.lookingFor,
    },
    {
      code: "city",
      name: t("city"),
      width: "130px",
      sortable: true,
      selector: (row) => row?.city,
    },
    {
      code: "contractType",
       name: (
        <div
          className="column-header"
          title={t("contractType")}
        >
          {t("lookingFor")}
        </div>
      ),
      width: "180px",
      sortable: true,
      selector: (row) => row?.contractType,
    },
    {
      code: "status",
      width: "120px",
      name: t("Status"),
      selector: (row) => row?.status,

      cell: (row) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const endDate = new Date(row?.durationToDate).setHours(0, 0, 0, 0);
        const isExpired = endDate < today;
        const isDisabled = isExpired || permissionAccess?.moduleAction === 0;

        return (
          <div
            className={`d-flex align-items-center gap-1 px-2 py-1 rounded-4 
          ${isDisabled ? "disabled-style" : "cursor-pointer"}
          ${isExpired
                ? "bg-gray-normal color-gray-bold"
                : row.status === 1
                  ? "bg-green-normal color-green-bold"
                  : "bg-red-normal color-red-bold"
              }`}
            onClick={(e) => {
              if (!isDisabled) {
                handleOpencloseJob(row?.id, row?.status === 1 ? 0 : 1);
              }
            }}
          >
            <div
              className={`rounded-circle ${isExpired
                ? "bg-gray-bold"
                : row.status === 1
                  ? "bg-green-bold"
                  : "bg-red-bold"
                }`}
              style={{ width: "10px", height: "10px" }}
            ></div>
            <p className="m-0 fs-14 fw-normal">
              {isExpired
                ? t("Expired")
                : row.status === 1
                  ? t("Open")
                  : t("Close")}
            </p>
          </div>
        );
      },
    },
    {
      name: t("My Matching"),
      selector: (row) => row?.detail,
      width: "130px",
      cell: (row) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const endDate = new Date(row?.durationToDate).setHours(0, 0, 0, 0);
        const isExpired = endDate < today;
        return (
          <div className="">
            <button className="border-0 bg-white">
              <button
                className="border-0 bg-white text-center"
                onClick={() => {
                  if (row?.status === 1 && !isExpired) {
                    navigate(
                      `${ROUTES.JOBPOTSLIST}/job-matching-list/${row?.title
                        .toLowerCase()
                        .replaceAll(" ", "-")}`,
                      {
                        state: { CareerId: row },
                      }
                    );
                  }
                }}
              >
                {isExpired || row.status === 0 ? (
                  <img
                    src={MATCHINGBLURICON}
                    alt="Matching Expired"
                    className="editicon ms-2"
                  />
                ) : (
                  <img
                    src={MYMATCHINGICONFORTable}
                    alt="View"
                    className="editicon ms-2"
                  />
                )}
              </button>
            </button>
          </div>
        );
      },
    },
    {
      name: t("Detail"),
      selector: (row) => row?.detail,
      cell: (row) => {
        const canView = permissionAccess?.viewAction === 1;

        return (
          <div>
            <button
              className={`border-0 bg-white ${!canView ? "disabled-style" : ""
                }`}
              onClick={() => {
                if (canView) addButtonClickModal("check", row);
              }}
              style={!canView ? { pointerEvents: "none", opacity: 0.6 } : {}}
            >
              <img
                src={DOCTOR_DETAIL_IAMGE}
                alt="View"
                className="editicon ms-2"
              />
            </button>
          </div>
        );
      },
    },

  ];

  const addJobPostNavigate = () => {
    navigate(`${ROUTES.JOBPOTSLIST}/job-post/add`);
  };

  const addButtonClickModal = (type, data) => {
    setViewData(data);
    setModalType(type);
    ViewMatchingmodal.current.click();
  };

  // permission code for this module start
  const [permissionAccess, setPermissionAccess] = useState();
  const rawPermission = useSelector((state) => state?.permission?.value);
  const permissions = decryptAEStoJSON(rawPermission);
  useEffect(() => {
    const RoleAccessFilterData =
      permissions &&
      permissions?.filter((v) => v.moduleName === "Matching Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, []);
  // permission code for this module end
  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <div className="main_datatable my-lg-3 my-2">
          <TableHeading
            title={t("My Requirement List")}
            searchValue={searchTerm}
            setSearchValue={setSearchTerm}
            data="Requirement"
            addButtonClick={addJobPostNavigate}
            showbutton={permissionAccess?.addAction === 1}
          />
          <div className="table-wrapper">
            <TableLayout
              _tblColumns={tableColumnsPosting}
              _rowData={rowData}
              pending={pending}
              pagination={true}
              selectableRows={false}
              setPending={setPending}
              _totalRows={totalRows}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPage={setPage}
              setSortColumn={setSortColumn}
              setSortDirection={setSortDirection}
            />
          </div>

          {/* Modal for Viewing Details */}
          <Modal
            modalId="viewPostDetails"
            closebtnclass="closebtnclass"
            modalClick={ViewMatchingmodal}
            modalContentClass="add_doctor card px-3 py-0 border border-radius_input"
            className={
              modalType === "check"
                ? "modal-lg"
                : modalType === "block"
                  ? "modal-lg"
                  : ""
            }
          >
            {modalType === "check" ? (
              <div className="">
                <div className="row text-start">
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.title || ""}
                      name="title"
                      placeHolder="Enter Title"
                      labelName="Title"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.country || ""}
                      name="country"
                      labelName="Country"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={
                        viewData?.durationFromDate
                          ? viewData?.durationFromDate?.split(" ")[0]
                          : ""
                      }
                      name="durationFromDate"
                      labelName="Requirement Start Date"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={
                        viewData?.durationToDate
                          ? viewData?.durationToDate?.split(" ")[0]
                          : ""
                      }
                      name="durationToDate"
                      labelName="Requirement End Date"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.profile || ""}
                      name="profile"
                      labelName="Profile"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.specialty || ""}
                      name="specialty"
                      labelName="Specialization"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.contractType || ""}
                      name="contractType"
                      labelName="Contract Type"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.lookingFor || ""}
                      name="lookingFor"
                      labelName="Job type"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.location || ""}
                      name="location"
                      labelName="Area / Location of Hospital"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.experience || ""}
                      name="experience"
                      labelName="Experience"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="mb-2  col-md-12 ">
                    <TextArea
                      labelName={t("Brief Description")}
                      name="description"
                      value={viewData?.description || ""}
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                </div>
              </div>
            ) : modalType === "block" ? (
              <div className="">
                <div className="row text-start">
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.title || ""}
                      name="title"
                      placeHolder="Enter Title"
                      labelName="Title"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={
                        viewData?.durationFromDate
                          ? viewData?.durationFromDate?.split(" ")[0]
                          : ""
                      }
                      name="durationFromDate"
                      labelName="Requirement Start Date"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={
                        viewData?.durationToDate
                          ? viewData?.durationToDate?.split(" ")[0]
                          : ""
                      }
                      name="durationToDate"
                      labelName="Requirement End Date"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.type || ""}
                      name="type"
                      labelName="Type"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.country || ""}
                      name="country"
                      labelName="Country"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.location || ""}
                      name="location"
                      labelName="Area / Location of Hospital"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.experience || ""}
                      name="experience"
                      labelName="Experience"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <TextArea
                      labelName="Brief Description"
                      name="description"
                      value={viewData?.description || ""}
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </Modal>
        </div>
      )}
    </>
  );
};

export default JobPostList;
